import { Store } from '../store';
import { useSelector } from 'react-redux';
import { Slice } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import {
    useDispatchedSliceActions,
    DispatchedActions,
} from './useDispatchedSliceActions';

export const useSlice = <S extends Slice, SKey extends keyof Store>(
    slice: S,
    storeKey: SKey
): {
    state: Store[SKey];
    actions: DispatchedActions<S>;
} => {
    const storeSlice = useSelector((store: Store) => store[storeKey]);
    const dispatchActions = useDispatchedSliceActions();

    const dispatchedActions: DispatchedActions<S> = useMemo(
        () => dispatchActions(slice.actions),
        [slice.name]
    );

    return {
        state: {
            ...storeSlice,
        },

        actions: {
            ...dispatchedActions,
        },
    };
};
